var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirefly(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 34,
    viewBox: "0 0 119 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4574 8.1651C15.2363 8.28678 13.9927 8.54527 12.774 8.24792C10.3133 7.80396 8.40312 5.67369 5.83509 5.6604C3.28017 5.98678 1.56239 8.17093 0 10.0187C1.48962 9.256 3.02517 7.86193 4.82152 8.48565C6.71817 9.31592 8.10209 11.4267 10.3515 11.3166C12.7087 11.0867 14.5991 9.48964 16.4574 8.1651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.5993 9.62467C31.6109 7.61217 34.0012 7.24877 35.5487 6.87388C32.7108 5.47387 29.6551 4.08725 26.3889 4.46575C22.1731 4.82351 18.8272 7.57017 15.4831 9.82057C13.6224 11.0283 11.5574 12.3697 9.21974 12.168C7.80845 12.0082 6.80414 10.9314 5.69678 10.1857C6.26504 12.461 7.31985 15.0573 9.89137 15.7215C15.8159 16.9576 21.122 12.9385 26.9377 12.8147C28.1563 12.6872 29.2561 13.8916 28.4736 14.9889C26.5291 18.1409 22.4008 18.9778 18.9011 18.8865C20.9544 20.9752 23.4342 23.0067 26.5232 23.245C30.0033 23.4881 33.2557 21.9376 36.4422 20.7906C33.8982 20.8061 31.0777 20.5436 29.3162 18.5174C31.8427 18.2745 34.336 17.757 36.7127 16.8723C34.669 14.7721 31.691 12.7996 31.5993 9.62467Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6376 20.228C15.7424 19.7678 14.0488 20.9495 12.6595 22.019C13.62 21.8911 14.5783 21.6039 15.5566 21.6994C18.1671 22.2126 19.1986 25.1482 21.7834 25.7065C23.7559 26.1031 25.5422 24.9301 27.2181 24.1369C26.206 24.0468 25.1629 24.0958 24.1787 23.81C21.7659 23.019 20.1215 20.8897 17.6376 20.228Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.1163 0.751423C39.3598 1.25319 38.8319 1.9078 38.5319 2.71483C38.3114 3.31362 38.2033 4.23056 38.2033 5.46432V7.41843H35.4468V9.83965H38.2033V25.7862H41.3041V9.83965H44.8902V7.41843H41.3041V5.72318C41.3041 4.6168 41.4993 3.862 41.8937 3.45838C42.2865 3.05476 42.9557 2.85203 43.9037 2.85203C44.48 2.85203 45.0933 2.91 45.7392 3.02583L46.2074 0.310997C45.1454 0.102541 44.1746 0 43.2963 0C41.9327 0 40.8745 0.24935 40.1163 0.751423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4734 25.7862H50.6383V7.54718H47.4734V25.7862Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4734 4.40249H50.6383V0.628906H47.4734V4.40249Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.5562 7.54477C59.941 7.96182 59.2707 8.82478 58.5457 10.1322V7.33537H55.7021V25.7861H58.8613V16.1273C58.8613 14.8066 59.0376 13.5905 59.3883 12.4792C59.6216 11.748 60.0136 11.1776 60.5645 10.7666C61.115 10.3553 61.7344 10.1497 62.4238 10.1497C63.1983 10.1497 63.9706 10.3765 64.7423 10.8285L65.8298 7.92701C64.7305 7.25393 63.6491 6.91821 62.5828 6.91821C61.8458 6.91821 61.1696 7.12761 60.5562 7.54477Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.885 14.6187C69.9889 13.0437 70.5342 11.7857 71.5168 10.8443C72.5009 9.90499 73.7132 9.43457 75.1571 9.43457C76.7518 9.43457 78.0493 10.0228 79.0492 11.2011C79.7025 11.9621 80.0978 13.1006 80.2361 14.6187H69.885ZM75.1221 6.91821C72.5614 6.91821 70.4778 7.75717 68.8722 9.43459C67.2659 11.1121 66.4628 13.4688 66.4628 16.505C66.4628 19.4404 67.2583 21.7215 68.8468 23.3457C70.4352 24.972 72.5847 25.7861 75.2974 25.7861C77.4491 25.7861 79.2191 25.2753 80.6047 24.2563C81.9882 23.236 82.9371 21.8031 83.4501 19.9546L80.203 19.5637C79.7259 20.8558 79.0788 21.7971 78.2639 22.3857C77.4491 22.9755 76.4671 23.2701 75.3133 23.2701C73.7654 23.2701 72.4734 22.7445 71.4385 21.6893C70.4023 20.6362 69.8267 19.1177 69.7097 17.1346H83.5361C83.5477 16.7704 83.5532 16.4994 83.5532 16.319C83.5532 13.338 82.768 11.0268 81.1967 9.38344C79.6261 7.74009 77.601 6.91821 75.1221 6.91821Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.8556 0.751423C88.0995 1.25319 87.5712 1.9078 87.2716 2.71483C87.0512 3.31362 86.9407 4.23056 86.9407 5.46432V7.41843H84.1862V9.83965H86.9407V25.7862H90.0432V9.83965H93.6296V7.41843H90.0432V5.72318C90.0432 4.6168 90.2391 3.862 90.6315 3.45838C91.0239 3.05476 91.6954 2.85203 92.6413 2.85203C93.2194 2.85203 93.8309 2.91 94.4785 3.02583L94.9468 0.310997C93.8828 0.102541 92.9137 0 92.0361 0C90.6724 0 89.6119 0.24935 88.8556 0.751423Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.5798 25.7861H98.7447V0.628906H95.5798V25.7861Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M115.839 7.54718L111.852 18.2391C111.348 19.5963 110.914 20.991 110.552 22.4176C110.153 20.9331 109.703 19.5173 109.199 18.1696L105.318 7.54718H101.91L108.989 25.9254C108.86 26.2587 108.765 26.5111 108.707 26.6846C108.263 27.9166 107.94 28.6881 107.742 28.9984C107.471 29.4134 107.126 29.7352 106.704 29.9665C106.283 30.1957 105.722 30.3114 105.018 30.3114C104.504 30.3114 103.9 30.2188 103.21 30.0358L103.561 32.9531C104.31 33.2076 104.988 33.3333 105.598 33.3333C106.606 33.3333 107.471 33.096 108.199 32.6178C108.924 32.1394 109.567 31.3877 110.13 30.3638C110.552 29.6039 111.144 28.216 111.905 26.2009L119 7.54718H115.839Z",
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirefly);
export default __webpack_public_path__ + "static/media/Firefly.2c0719453481dac2dd790ebbdb58a66e.svg";
export { ForwardRef as ReactComponent };